import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, FormInstance, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { emaillogin } from "../axios/api.account";
import {
  SwitchMenu
} from "../redux/actions";
import Store from "../redux/store";
import "./pages.scss";
export function Login() {
    const { t } = useTranslation();
    const formRef = React.createRef<FormInstance>();
    function submitClick(){
      formRef?.current?.validateFields().then(res=>{
        console.log(res);
        emaillogin(res).then(rs=>{
            localStorage.setItem("jt", rs.token);
            Store.dispatch(SwitchMenu("Index"));
            window.location.href='/home/index';
          },()=>{
              //notification.error({ message: "申请失败" });
          })
      })
  }
    return (
      <div className="login-container" style={{backgroundImage: "url(images/bg.png)"}}>  
      <div className="logo-container">  
        {/* 这里应该放置TAPD的Logo */}  
        <h1>{t("未瓴移动设备管理平台")}</h1>
      </div>

              <Form
                ref={formRef}
                className="login-form" 
                name="basic"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 16 }}
                //style={{ maxWidth: 600 }}
                autoComplete="off"
              >
                <Form.Item
                  label={t("邮箱")}
                  name="email"
                  rules={[{ required: true, message: t('请输入邮箱') }]}
                >
                  <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder={t("邮箱")} />
                </Form.Item>

                <Form.Item
                  label={t("密码")}
                  name="password"
                  rules={[{ required: true, message: t('请输入密码') }]}
                >
                  <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder={t("密码")} />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                  <Button type="primary" onClick={() => { submitClick(); } } className="login-form-button" htmlType="submit">
                    {t("Sign in")}
                  </Button>
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 4, span: 16 }} >
                  <div className="login-form-a">
                      <a href="/register">{t("注册")}</a>
                      <a href="/forgetpwd" >{t("忘记密码？")}</a>
                  </div>
                </Form.Item>
              </Form>
              {/* <div style={{display:"flex",textAlign:"center"}}>
                <a>注册</a>
                <a>忘记密码？</a>
              </div> */}
        </div> 
    )
}